var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSolidB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80957 7.77778C8.87044 7.77778 9.88785 7.36806 10.638 6.63875C11.3881 5.90944 11.8096 4.92029 11.8096 3.88889C11.8096 2.85749 11.3881 1.86834 10.638 1.13903C9.88785 0.409721 8.87044 0 7.80957 0C6.7487 0 5.73129 0.409721 4.98114 1.13903C4.231 1.86834 3.80957 2.85749 3.80957 3.88889C3.80957 4.92029 4.231 5.90944 4.98114 6.63875C5.73129 7.36806 6.7487 7.77778 7.80957 7.77778ZM6.38145 9.23611C3.30332 9.23611 0.80957 11.6606 0.80957 14.6532C0.80957 15.1515 1.2252 15.5556 1.7377 15.5556H13.8814C14.3939 15.5556 14.8096 15.1515 14.8096 14.6532C14.8096 11.6606 12.3158 9.23611 9.2377 9.23611H6.38145Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15.5556,
    fill: "white",
    transform: "translate(0.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolidB);
export default __webpack_public_path__ + "static/media/user-solid-b.422e3af04f0e0c09a92a8f497b45e962.svg";
export { ForwardRef as ReactComponent };